import { createContext } from 'react';

const CoreListContext = createContext({});

export default CoreListContext;
